import React from 'react';
var ExpandCollapseSkeleton = function () { return (React.createElement("div", { className: "row" },
    React.createElement("div", { className: "skeleton-line skeleton-h-xl col-md-12" }))); };
export default React.memo(ExpandCollapseSkeleton);
